import React from 'react';
import HomepageNav from '../components/HomepageNav';
import MobileNav from '../components/MobileNav';
import Footer from '../components/Footer';
import pdfDe from '../assets/documents/AAB_2018_de.pdf';
import pdfEn from '../assets/documents/AAB_2018_en_16.05.2018.pdf';
import './Impressum.css';

const Impressum = () => {
  return (
    <div className="impressum-page">
      <HomepageNav />
      <MobileNav />
      <main className="impressum-page__content">
        <h1 className="impressum-page__title">Impressum</h1>

        <section className="impressum-page__section">
          <h2 className="impressum-page__section-title">Nintschew & Partner</h2>
          <p className="impressum-page__text">Steuer- und Wirtschaftsberatung GmbH & Co KG</p>
          <address className="impressum-page__address">
            Andreas-Huger-Gasse 6/1/49
            <br />
            1220 Wien
          </address>
        </section>

        <section className="impressum-page__grid">
          <div className="impressum-page__card">
            <h3 className="impressum-page__card-title">Unternehmensgegenstand</h3>
            <p className="impressum-page__text">Steuerberatung und Beratung in Wirtschaftsangelegenheiten</p>
          </div>

          <div className="impressum-page__card">
            <h3 className="impressum-page__card-title">Rechtsform</h3>
            <p className="impressum-page__text">GmbH &amp; Co KG</p>
          </div>

          <div className="impressum-page__card">
            <h3 className="impressum-page__card-title">Firmenbuchnummer- und gericht</h3>
            <p className="impressum-page__text">FN 585156z, Handelsgericht Wien</p>
          </div>

          <div className="impressum-page__card">
            <h3 className="impressum-page__card-title">UID</h3>
            <p className="impressum-page__text">ATU78454469</p>
          </div>

          <div className="impressum-page__card">
            <h3 className="impressum-page__card-title">Gesellschafterverhältnisse:</h3>
            <p className="impressum-page__text">Nintschew FlexCo, Kommanditist</p>
            <p className="impressum-page__text">Nintschew & Partner Steuer- und Wirtschaftsberatung GmbH, Komplementär</p>
          </div>

          <div className="impressum-page__card">
            <h3 className="impressum-page__card-title">Geschäftsführung</h3>
            <p className="impressum-page__text">
              Nintschew &amp; Partner Steuer- und Wirtschaftsberatung GmbH, vertreten durch Andrei Nintschew
            </p>
          </div>

          <div className="impressum-page__card">
            <h3 className="impressum-page__card-title">Kammerzugehörigkeit</h3>
            <p className="impressum-page__text">​​​​​​​Mitglied der Kammer der Wirtschaftstreuhänder</p>
            <p className="impressum-page__text">Wirtschaftstreuhänder-Code: 807965</p>
          </div>


        </section>

        <section className="impressum-page__section">
          <h3 className="impressum-page__section-title">Auftragsbedingungen</h3>
          <div className="impressum-page__links">
            <a
              className="impressum-page__link"
              href={pdfDe}
              target="_blank"
              rel="noopener noreferrer"
            >
              AAB 2018 (DE)
              <img className="impressum-page__icon" src="/img/download.svg" alt="" aria-hidden="true" />
            </a>
            <a
              className="impressum-page__link"
              href={pdfEn}
              target="_blank"
              rel="noopener noreferrer"
            >
              AAB 2018 (EN)
              <img className="impressum-page__icon" src="/img/download.svg" alt="" aria-hidden="true" />
            </a>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default Impressum;


